/**
 * Shim de PRODUÇÃO para react/jsx-dev-runtime.
 *
 * O dist do @astryxdesign é publicado com JSX transformado em modo dev
 * (`import { jsxDEV } from "react/jsx-dev-runtime"`). No React de produção
 * `jsxDEV` é `void 0` → "(0, X.jsxDEV) is not a function" em runtime.
 * O craco (craco.config.js) aponta react/jsx-dev-runtime para este arquivo
 * SOMENTE no build de produção, redirecionando jsxDEV para o jsx/jsxs reais.
 */
import { jsx, jsxs, Fragment } from "react/jsx-runtime";

export { Fragment };

export function jsxDEV(type, config, maybeKey, isStaticChildren) {
  return isStaticChildren
    ? jsxs(type, config, maybeKey)
    : jsx(type, config, maybeKey);
}
